module.exports = __webpack_public_path__ + "static_1782112809526/img/timg.c977239a.gif";